export const iconFontAwesomeBuildingsKaaba = (
	<i className="fa-solid fa-kaaba"></i>
);
